
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7115/api/',
    //Live

    //DEV
   

    // Live
    apiUrl: 'https://bps-api.solegaze.com/api/',

    apiKey: 'Lieda1002',

    // EmailJS configuration — sign up free at https://www.emailjs.com
    // 1. Create an Email Service (Gmail, Outlook, etc.)
    // 2. Create an Email Template with these variables:
    //    {{to_email}}, {{to_name}}, {{from_name}}, {{subject}}, {{message}}, {{invoice_pdf}} (attachment)
    // 3. Copy your Service ID, Template ID, and Public Key here
    emailjs: {
        serviceId: 'service_xltwcq7',      // e.g. 'service_abc123'
        templateId: 'template_rjv20qg',    // e.g. 'template_xyz789'
        publicKey: 'XwVsrx14cdwmAFhCC',      // e.g. 'AbCdEfGhIjKlMnOp'
    },
};

export default apiConfig;

